// Recovered compiled webpack factory 20063. Edit this function expression; run npm run build.
(e, t, n) => {
  "use strict";
  var r = n(47260);
  (n.o(r, "useParams") &&
    n.d(t, {
      useParams: function () {
        return r.useParams;
      },
    }),
    n.o(r, "usePathname") &&
      n.d(t, {
        usePathname: function () {
          return r.usePathname;
        },
      }),
    n.o(r, "useRouter") &&
      n.d(t, {
        useRouter: function () {
          return r.useRouter;
        },
      }),
    n.o(r, "useSearchParams") &&
      n.d(t, {
        useSearchParams: function () {
          return r.useSearchParams;
        },
      }));
}
